const VALID_SEMVER = /^(\d+\.\d+\.\d+(-\w+)?)/;

const getValidSemver = (value?: string) => {
    return (value?.match(VALID_SEMVER) ?? [])[0];
};

export default getValidSemver;
